import { render, staticRenderFns } from "./NewVersionAvailableDialog.vue?vue&type=template&id=71077538"
import script from "./NewVersionAvailableDialog.vue?vue&type=script&lang=js"
export * from "./NewVersionAvailableDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports